import { render, staticRenderFns } from "./bindingContract.vue?vue&type=template&id=b84e18ac&scoped=true"
import script from "./bindingContract.vue?vue&type=script&lang=js"
export * from "./bindingContract.vue?vue&type=script&lang=js"
import style0 from "./bindingContract.vue?vue&type=style&index=0&id=b84e18ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84e18ac",
  null
  
)

export default component.exports